import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root'
})
export class DataAccessService {

  // State management for departments
  public departments$ = new BehaviorSubject<any[]>([]);
  private isDepartmentsLoading = false;

  constructor(private apiService: ApiBaseService) { }

  async getDepartments(payLoad: any): Promise<any> {
    const result = await this.apiService.httpRequest('DataAccessService/GetDepartments', payLoad, true, true);

    // Update departments state if available
    if (!result.hasError && result.departmentItems) {
      this.departments$.next(result.departmentItems);
    }

    return result;
  }

  async loadDepartments(forceReload: boolean = false): Promise<any[]> {
    if (!forceReload && this.departments$.value.length > 0) {
      return this.departments$.value;
    }

    if (this.isDepartmentsLoading) {
      return this.departments$.value;
    }

    this.isDepartmentsLoading = true;
    try {
      const result = await this.getDepartments({});
      return this.departments$.value;
    } finally {
      this.isDepartmentsLoading = false;
    }
  }

  async getContractTypes(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('DataAccessService/GetContractTypes', payLoad, true, true);
  }

  async getContractAreaTypes(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('DataAccessService/GetContractAreaTypes', payLoad, true, true);
  }
}
